import React, { Component, PropTypes } from 'react';
import ace from 'brace';
import AceEditor from 'react-ace';
import tracking from './trackingVariables';
import 'brace/mode/html';
import 'brace/theme/twilight';
import 'brace/ext/language_tools';

let lng = ace.acequire('ace/ext/language_tools');

class Editor extends Component {
    constructor(props) {
        super(props);

        const customCompleter = {
            getCompletions: function(editor, session, pos, prefix, callback) {
                callback(
                    null,
                    tracking.map(val => {
                        return {
                            caption: `CRS ${val.name}`,
                            value: `CRS ${val.name}`,
                            meta: 'CRS_TRACK',
                            snippet: val.value
                        };
                    })
                );
            },
            insertMatch: function(editor, data) {
                if (editor.completer.completions.filterText) {
                    var ranges = editor.selection.getAllRanges();
                    for (var i = 0, range; (range = ranges[i]); i++) {
                        range.start.column -= editor.completer.completions.filterText.length;
                        editor.session.remove(range);
                    }
                }
                editor.execCommand('insertstring', data.meta);
            }
        };

        lng.addCompleter(customCompleter);
    }

    _handleSave() {
        return this.props.onSave(this.props.value);
    }

    render() {
        const sections = (this.props.editedSection && this.props.editedSection.split('.')) || [];

        return (
            <div>
                <div className="row">
                    <div className="col-xs-12">
                        {this.props.title && <h4>{this.props.title}</h4>}
                        {this.props.title && (
                            <p>
                                Enter code that will be injected into the '{sections[0]}' tag on '
                                {sections[1] ? sections[1] : 'every'}' page of the site.
                            </p>
                        )}
                    </div>
                </div>
                <div className={'row'}>
                    <div className="col-xs-8">
                        <AceEditor
                            ref={el => (this.editor = el)}
                            mode="html"
                            theme="twilight"
                            width="100%"
                            name="blah2"
                            value={this.props.value}
                            highlightActiveLine
                            showGutter
                            readOnly={this.props.disabled}
                            showPrintMargin
                            onChange={value => this.props.onChange(value)}
                            setOptions={{
                                enableBasicAutocompletion: true,
                                enableLiveAutocompletion: true,
                                enableSnippets: false,
                                showLineNumbers: true,
                                tabSize: 2
                            }}
                        />
                    </div>
                    <div className="col-xs-4">
                        <div className="spark-mar-b-.5">
                            <button
                                className={`spark-btn spark-btn--block spark-btn--sm ${
                                    this.props.disabled ? 'disabled' : ''
                                }`}
                                onClick={() => this._handleSave()}
                            >
                                Save
                            </button>
                        </div>
                        <div className="spark-menu--panel">
                            <div className="spark-pad-.5 spark-text-left variables-menu">
                                <h4>Variables</h4>
                                <ul>
                                    {tracking.map((item, index) => {
                                        return (
                                            <li style={{ lineHeight: '1.2rem' }} key={item.js + index}>
                                                <div style={{ fontWeight: 700, fontSize: '1.1rem' }}>{item.name}</div>
                                                <small>{item.js.split('&&').pop()}</small>
                                            </li>
                                        );
                                    })}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

Editor.defaultProps = {
    disabled: false
};

Editor.propTypes = {
    disabled: PropTypes.bool
};

export default Editor;



// WEBPACK FOOTER //
// ./src/components/widgets/Editor/editor.js